import Vue from 'vue'
import BlockFactory from '@/models/blocks'

const state = () => ({
  list: [],
  cached: {},
  inViewport: []
})

const actions = {
  add({ commit, dispatch }, { mod, blocks, index }) {
    if (mod) {
      const block = BlockFactory.create(mod.type)
      commit('ADD', { block, index })
      dispatch('editor/change', null, { root: true })
    }
    if (blocks) {
      blocks.forEach((block, index) => {
        block = BlockFactory.create(block.type, block)
        commit('ADD', { block, index })
        dispatch('editor/change', null, { root: true })
      })
    }
  },

  move({ commit, dispatch }, { id, index }) {
    commit('MOVE', { id, index })
    dispatch('editor/change', null, { root: true })
  },

  remove({ commit, dispatch }, { id }) {
    commit('REMOVE', { id })
    dispatch('editor/change', null, { root: true })
  },

  reset({ commit }) {
    commit('RESET')
  },

  update({ commit, dispatch }, { uid, data }) {
    commit('UPDATE', { uid, data })
    dispatch('editor/change', null, { root: true })
  },

  enterViewport({ commit }, uid) {
    commit('ENTER_VIEWPORT', uid)
  },

  exitViewport({ commit }, uid) {
    commit('EXIT_VIEWPORT', uid)
  }
}

const mutations = {
  ADD(state, { block, index }) {
    Vue.set(state.cached, block.uid, block)
    if (state.list.indexOf(block.uid) === -1) {
      state.list.splice(index, 0, block.uid)
    }
  },

  MOVE(state, { id, index }) {
    const from = state.list.indexOf(id)
    const to = index
    // Doesn't need to change position on click the target context.
    if (to === from || to === from + 1) {
      return
    }
    state.list.splice(from < to ? to - 1 : to, 0, state.list.splice(from, 1)[0])
  },

  REMOVE(state, { id }) {
    state.list.splice(state.list.indexOf(id), 1)
    Vue.delete(state.cached, id)
  },

  // The first argument is the state context of this moudle, that conflict with
  // the function for reset state. `_state` used to bypass this issue.
  RESET(_state) {
    const init = state()
    Object.keys(init).forEach(key => {
      _state[key] = init[key]
    })
  },

  UPDATE(state, { uid, data }) {
    Object.keys(data).forEach(key => {
      const target = state.cached[uid]
      const value = data[key]

      Vue.set(target, key, value)
    })
  },

  ENTER_VIEWPORT(state, uid) {
    const index = state.inViewport.indexOf(uid)
    if (index !== -1) {
      return
    }
    state.inViewport.push(uid)
  },

  EXIT_VIEWPORT(state, uid) {
    const index = state.inViewport.indexOf(uid)
    if (index === -1) {
      return
    }
    state.inViewport.splice(index, 1)
  }
}

const getters = {
  item(state) {
    return function (id) {
      return state.cached[id]
    }
  },

  // 將區塊清單轉換為可讀的清單
  anchors(state) {
    return state.list
      .map(id => state.cached[id])
      .filter(_ => _)
      .map(block => {
        return {
          id: block.uid,
          type: block.type,
          text: block.alias
        }
      })
  },

  selected(state, getters, rootState, rootGetters) {
    const id = rootState.route.params.block_id
    return state.cached[id]
  }
}

export default { namespaced: true, state: state(), actions, mutations, getters }



// WEBPACK FOOTER //
// ./src/store/modules/editor/blocks.js